<template>
  <b-card
    no-body
    :class="[{'open': visible}, 'queue-specialists', margin]"
    @mouseenter="collapseOpen"
    @mouseleave="collapseClose"
  >
    <b-card-img
      v-if="service.image"
      :src="service.image"
      alt="Image"
      top
      @click="updateVisible(!visible)"
    />
    <b-card-header
      :class="[{'collapsed': !visible}, 'queue-card-header']"
      :aria-expanded="visible ? 'true' : 'false'"
      :aria-controls="collapseItemID"
      role="tab"
      data-toggle="collapse"
      @click="updateVisible(!visible)"
    >
      <b-container class="bv-example-row">
        <b-row align-h="between">
          <span
            cols="9"
            align="start"
            name="header"
            class="col justify-content-start"
          >
            <b-col class="col justify-content-start pl-0 pr-0">
              <span class="lead collapse-title queue-bloc-title">{{ service.name }}</span><br>
              <small class="text-secondary">{{ service.description }}</small>
            </b-col>
          </span>
          <b-col
            cols="3"
            align="center"
            class="p-0 d-flex align-items-center justify-content-center"
          >
            <b-badge
              :style="{backgroundColor: getWidgetSettings.main_color}"
              pill
              class="mt-1 mr-1 mb-1 badge-round"
            >
              <b-overlay
                :show="isLoading && getWidgetSettings.timeslot_display_mode === 1"
                spinner-small
                variant="transparent"
                spinner-type="grow"
                size="sm"
                rounded="sm"
                opacity="0.6"
              >
                {{ getWidgetSettings.currency }} {{ service.price }}
              </b-overlay>
            </b-badge>
          </b-col>
        </b-row>
      </b-container>
    </b-card-header>

    <b-collapse
      :id="collapseItemID"
      v-model="visible"
      :accordion="accordion"
      role="tabpanel"
    >
      <InlineCalendar
        v-if="getWidgetSettings.timeslot_display_mode === 2"
        ref="inlineCalendar"
        :workspace="workspace"
        :service="service.id"
        @select-date="selectDate"
        @openModal="showForm"
      />
      <GridCalendar
        :visible="visible"
        :exist-timeslots="existTimeslot"
        @openForm="showForm"
      />
    </b-collapse>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCollapse, BCol, BRow, BContainer, BBadge, BOverlay, BCardImg,
} from 'bootstrap-vue'
import { v4 as uuidv4 } from 'uuid'
import Ripple from 'vue-ripple-directive'
// import axios from '@/libs/axios'
import i18n from '@/libs/i18n'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import InlineCalendar from '@/components/booking/calendars/inline/InlineCalendar.vue'
import GridCalendar from '@/components/booking/calendars/grid/GridCalendar.vue'
import { getFormattedDateForBackend } from '@/libs/utils'

export default {
  directives: {
    Ripple,
  },
  components: {
    BCard,
    BCardHeader,
    BCollapse,
    BCol,
    BRow,
    BContainer,
    BBadge,
    BOverlay,
    BCardImg,
    InlineCalendar,
    GridCalendar,
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    service: {
      type: Object,
      required: true,
    },
    workspace: {
      type: Object,
      required: true,
    },
    margin: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selectedDate: getFormattedDateForBackend(new Date()),
      isLoading: false,
      visible: false,
      collapseItemID: '',
      openOnHover: this.$parent.hover,
      existTimeslot: true,
      i18n,
    }
  },
  computed: {
    ...mapGetters(['getWidgetSettings']),
    accordion() {
      return this.$parent.accordion ? `accordion-${this.$parent.collapseID}` : null
    },
  },
  created() {
    this.collapseItemID = uuidv4()
    this.visible = this.isVisible
  },
  methods: {
    ...mapActions(['fetchAllDaysTimeslots', 'fetchDayTimeslotsAndCountdown']),
    ...mapMutations(['UPDATE_ALL_TIMESLOTS']),
    setLoading(val) {
      if (this.getWidgetSettings.timeslot_display_mode === 2) {
        if (val) {
          this.isLoading = val
          this.$refs.inlineCalendar.setLoading(val)
          return
        }
        setTimeout(() => {
          this.isLoading = val
          this.$refs.inlineCalendar.setLoading(val)
        }, 500)
      } else {
        this.isLoading = val
      }
    },
    selectDate(val) {
      this.setLoading(true)
      this.selectedDate = getFormattedDateForBackend(val)
      this.fetchTimeslotsForCalendarTypeTwo()
    },
    showForm(val) {
      this.$emit('openForm', { timeslot: val.timeslot, day: val.day, service: this.service })
    },
    async updateVisible(val = true) {
      if (val === true) {
        this.setLoading(true)
        if (this.workspace.category === 1 && this.getWidgetSettings.timeslot_display_mode === 1) {
          await this.fetchTimeslotsForCalendarTypeOne()
        } else if (this.workspace.category === 1 && this.getWidgetSettings.timeslot_display_mode === 2) {
          await this.fetchTimeslotsForCalendarTypeTwo()
        }
      } else {
        this.UPDATE_ALL_TIMESLOTS([])
      }
      this.visible = val
      // this.$emit('visible', val)
    },
    countTimeslots(res) {
      let count = 0
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < res.timeslots.length; ++i) {
        if (res.timeslots[i].length > 0) {
          count += 1
        }
      }
      if (count === 0) {
        this.existTimeslot = false
      }
    },
    collapseOpen() {
      if (this.openOnHover) this.updateVisible(true)
    },
    collapseClose() {
      if (this.openOnHover) this.updateVisible(false)
    },
    async fetchTimeslotsForCalendarTypeOne() {
      await this.fetchAllDaysTimeslots({ workspace: this.workspace.id, service: this.service.id })
        .then(response => {
          this.countTimeslots(response)
          this.setLoading(false)
        })
        .catch(error => {
          this.setLoading(false)
          console.error(error)
        })
    },
    fetchTimeslotsForCalendarTypeTwo() {
      const data = {
        workspace: this.workspace.id,
        services: [this.service.id],
        day: getFormattedDateForBackend(this.selectedDate),
        start_time: null,
        record: null,
      }
      this.fetchDayTimeslotsAndCountdown(data).then(response => {
        this.timeslots = response.data.timeslots
        this.setLoading(false)
      }).catch(error => {
        this.setLoading(false)
        console.error(error)
      })
    },
  },
}
</script>
<style>

</style>
